import { HttpClient } from "@utils/index";
import type {
  DocumentTypeInfoViewModel,
  DocumentTypeInfoModel,
} from "@models/doctype";
import { buildDocumentTypesInfoViewModel } from "@utils/builders/doctype";

const BASE_URL = import.meta.env.VITE_EXTRACTION_API_BASE_URL;

if (!BASE_URL) {
  throw new Error(
    "Missing required environment variable: VITE_EXTRACTION_API_BASE_URL. " +
      "Please check your .env file and ensure the Intelligence Engine API URL is set.",
  );
}

class DocTypeApi {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(`${BASE_URL}`);
  }

  async getDoctypes(): Promise<DocumentTypeInfoViewModel[]> {
    const response = await this.httpClient.makeAuthenticatedRequest<
      DocumentTypeInfoModel[]
    >(`/doctypes`, {
      method: "GET",
    });
    return buildDocumentTypesInfoViewModel(response);
  }
}

export { DocTypeApi };

export const docTypeApi = new DocTypeApi();
